import CargoInformation from "./Form.cargo.information/Form.cargo.information";
import ConsigneeInformation from "./Form.consignee.information/Form.consignee.information";
import LocationInformation from "./Form.location.information/Form.location.information";
import ShipperInformation from "./Form.shipper.information/Form.shipper.information";


const Forms = {
    ShipperInformation,
    ConsigneeInformation,
    LocationInformation,
    CargoInformation
}

export default Forms;